export default function Loader({ label }) {
  return (
    <div className="loader-wrap" style={{ flexDirection: 'column', gap: 16 }}>
      <div className="spinner" />
      {label && <p className="muted">{label}</p>}
    </div>
  );
}
